import { Component } from '@angular/core';
import { SideBarService } from './sidebar/sidebar.service';

@Component({
  selector: 'ntc-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'ntc';

  constructor(public sideBar: SideBarService) { }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts